import { render, staticRenderFns } from "./FormVideoItem.vue?vue&type=template&id=2e6d6e6c"
import script from "./FormVideoItem.vue?vue&type=script&lang=js"
export * from "./FormVideoItem.vue?vue&type=script&lang=js"
import style0 from "./FormVideoItem.vue?vue&type=style&index=0&id=2e6d6e6c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6d6e6c')) {
      api.createRecord('2e6d6e6c', component.options)
    } else {
      api.reload('2e6d6e6c', component.options)
    }
    module.hot.accept("./FormVideoItem.vue?vue&type=template&id=2e6d6e6c", function () {
      api.rerender('2e6d6e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormVideoItem.vue"
export default component.exports